import { Text, View } from '@react-pdf/renderer'
import { ReactElement } from 'react'

import { sanitizeCurrencyForPdf } from '@features/exports/utils/sanitizeCurrencyForPdf'

import { pdfStyles } from './utils/pdfStyles'

interface SalesReportPdfTableFooterProps {
  footerLabel: string
  totalSales: string
}

export const SalesReportPdfTableFooter = ({
  footerLabel,
  totalSales,
}: SalesReportPdfTableFooterProps): ReactElement => {
  return (
    <View style={pdfStyles.tableFooterRow}>
      <Text>{footerLabel}</Text>
      <Text>{sanitizeCurrencyForPdf(totalSales)}</Text>
    </View>
  )
}
